<div class="main-container">
    <div *ngIf="!isLoading">
        <mat-horizontal-stepper linear #stepper>
            <mat-step (click)="stepClicked('Course')">
                <ng-template matStepLabel>Batch Detail</ng-template>
                <app-batch-detail [batchId]="batchId" (moveToActivity)="moveToModule($event)">
                </app-batch-detail>
            </mat-step>
            <mat-step (click)="stepClicked('Module')">
                <ng-template matStepLabel>Curriculum Detail</ng-template>
                <app-curriculum-detail [batchId]="batchId" (moveToActivity)="moveToActivity($event)"
                    (moveToPrevious)="moveToPrevious()"></app-curriculum-detail>
            </mat-step>
            <!-- <mat-step (click)="stepClicked('Activity')">
                <ng-template matStepLabel>Activity Detail</ng-template>
                <app-activity-detail *ngIf="showActivityDetails"
                    (moveToPrevious)="moveToPrevious()"></app-activity-detail>
            </mat-step> -->
        </mat-horizontal-stepper>
    </div>
</div>